/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { parseUrl } from "query-string";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import useAuthorizedRequest from "components/AuthorizedRequest";
import { Alert, Snackbar } from "@mui/material";

function CategoryAdd() {
  const authorizedReq = useAuthorizedRequest();
  const urlPage = parseUrl(window.location.href);
  const categoryId = urlPage.query.id;
  const navigate = useNavigate();

  // const [status, setStatus] = useState(1);
  const [categoryData, setCategoryData] = useState({
    category_name: "",
    status: "",
  });
  const [snackProps, setSnackProps] = useState({
    message: "",
    severity: "info",
    isOpen: false,
  });

  useEffect(() => {
    authorizedReq
      .get(`${process.env.REACT_APP_API_BASE_URL}/category/${categoryId}`)
      .then((resCategory) => {
        setCategoryData({
          category_name: resCategory.data.category_name,
          status: resCategory.data.status,
        });
      })
      .catch((errCategory) => {
        setSnackProps({
          isOpen: true,
          message: errCategory.response.data.message,
          severity: "error",
        });
      });
  }, []);

  // const handleStatusChange = (event) => {
  //   setStatus(event.target.value);
  // };

  const handleSnackClose = () => {
    setSnackProps({ ...snackProps, isOpen: false });
  };

  const handleUpdateCategory = () => {
    authorizedReq
      .put(`${process.env.REACT_APP_API_BASE_URL}/category/${categoryId}`, categoryData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(() => {
        setSnackProps({
          isOpen: true,
          message: "Category Updated Successfully",
          severity: "success",
        });
        navigate(-1);
      })
      .catch((err) => {
        setSnackProps({
          isOpen: true,
          message: err.response.data.message,
          severity: "error",
        });
        // console.log(categoryData);
      });
  };

  return (
    <DashboardLayout>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackProps.isOpen}
          onClose={handleSnackClose}
          autoHideDuration={6000}
        >
          <Alert onClose={handleSnackClose} severity={snackProps.severity} sx={{ width: "100%" }}>
            {snackProps.message}
          </Alert>
        </Snackbar>
      </div>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              <MDBox pt={4} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleUpdateCategory();
                  }}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="text">Category Name</MDTypography>
                    <MDInput
                      value={categoryData.category_name}
                      onChange={(e) =>
                        setCategoryData({
                          category_name: e.target.value,
                          status: categoryData.status,
                        })
                      }
                      type="input"
                      fullWidth
                      placeholder="Category Name"
                      disabled
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDTypography variant="text">Status</MDTypography>
                    <Select
                      labelId="status"
                      id="status"
                      value={categoryData.status}
                      label="status"
                      variant="standard"
                      defaultValue=""
                      onChange={(e) =>
                        setCategoryData({
                          category_name: categoryData.category_name,
                          status: e.target.value,
                        })
                      }
                      fullWidth
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </MDBox>
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      variant="gradient"
                      color="info"
                      fullWidth
                      onClick={handleUpdateCategory}
                    >
                      Update
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CategoryAdd;
